import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

import TimelineInnerNavi from './timelineInnerNavi';

import Iconset from './icons';

class Timeline extends React.Component{

	constructor(props){
		super(props);

	}
	
	togglePlay(){
		if(this.props.isPlaying){
			this.props.pause();
		}else{
			this.props.play();
		}
	}

	goToOutro(){

		browserHistory.push(_assets.root + '/outro');
	}

	render(){
		let offset = 0;
		let fac = .25;
		if(this.props.innerChapter == 1){
			offset = 25;
			fac = 0.05;
		}else if(this.props.innerChapter==2){
			offset = 30;
			fac = .7;
		}else {
			offset = 0;
		}

		let calculatedTrackTime = offset + (parseFloat(this.props.currentInnerChapterTime) * fac);
		let timelineTrackStyle = {
			width :  calculatedTrackTime +'%'
		}
		let publicChapter = this.props.innerChapter +1 ;
		
		return (
			<div className="flex-box timeline-holder">
				<div className="timeline-inner">
					<button className={"play-button isPlaying-"+ this.props.isPlaying} onClick={()=>this.togglePlay()}>
						{ this.props.isPlaying && 
								<Iconset.pause/>
							}{ !this.props.isPlaying && 
									<Iconset.play/>
								}</button>
					{/*<div className="currentTime helper">{this.props.innerChapter} | {this.props.currentInnerChapterTime}</div>*/}
					<TimelineInnerNavi />
					<div className="timeline-track">
						<div className="timeline-track-slider" style={timelineTrackStyle}></div>
						<div className={"timeline-track-marker-holder active-marker-" + publicChapter}>
							<button className="timeline-track-marker marker-1" data-name="0" onClick={(event)=>this.props.goToInnerChapter(event)}>
								<span className="tool-tip" data-name="0">#intro</span>
							</button>
							<button className="timeline-track-marker marker-2" data-name="1" onClick={(event)=>this.props.goToInnerChapter(event)}>
								<span className="tool-tip" data-name="1">#introsession</span>
							</button>
							<button className="timeline-track-marker marker-3" data-name="2" onClick={(event)=>this.props.goToInnerChapter(event)}>
								<span className="tool-tip" data-name="2">#livesession</span>
							</button>
							<button className="timeline-track-marker marker-4" data-name="3" onClick={this.goToOutro}>
								<span className="tool-tip" data-name="3">#outro</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			)
	}

}


export default Timeline;


// WEBPACK FOOTER //
// ./src/scripts/timeline.js